import React from "react";
import { FONT_BODY } from "../utils/designTokens";

/**
 * TEMPORARY debug error boundary. Instead of a blank page on a render crash,
 * it shows the actual error message, the component stack, and the JS stack —
 * so we can see exactly what threw on RestaurantDetail / Checkout.
 *
 * Remove (or replace with a friendly fallback) once the bug is fixed.
 */
class DebugErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Also log to the browser console so it's copyable.
    // eslint-disable-next-line no-console
    console.error("[DebugErrorBoundary] caught:", error, info?.componentStack);
    this.setState({ error, info });
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    const box = {
      margin: "20px",
      padding: "20px",
      border: "2px solid #DC2626",
      borderRadius: 12,
      background: "#FEF2F2",
      color: "#7F1D1D",
      fontFamily: FONT_BODY,
      fontSize: 13,
      lineHeight: 1.5,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      maxWidth: 900,
    };
    const h = { fontWeight: 700, marginTop: 12, marginBottom: 4, color: "#991B1B" };

    return (
      <div style={box}>
        <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 8 }}>
          ⚠️ A render error was caught (debug boundary)
        </div>
        <div style={h}>Message</div>
        <div>{String(error && error.message)}</div>
        <div style={h}>Error stack</div>
        <div>{String(error && error.stack)}</div>
        <div style={h}>Component stack</div>
        <div>{info && info.componentStack ? info.componentStack : "(none)"}</div>
        <button
          onClick={() => this.setState({ error: null, info: null })}
          style={{
            marginTop: 16,
            padding: "8px 16px",
            background: "#DC2626",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 700,
          }}
        >
          Dismiss
        </button>
      </div>
    );
  }
}

export default DebugErrorBoundary;
